import React from "react";
import { useTranslation } from "react-i18next";

import "./Pagination.css";

function Pagination({ pagedata, onPageChange }) {
  const { t } = useTranslation();

  const getPageRangeText = () => {
    const startRange = (pagedata.currentPage - 1) * 10 + 1;
    const endRange = Math.min(pagedata.currentPage * 10, pagedata.totalDocs);

    return `${startRange}-${endRange} of ${pagedata.totalDocs}`;
  };

  return (
    <div className="pagination">
      <p>
        {" "}
        {t("showing")} {getPageRangeText()}
      </p>
      <div className="paginationbtns">
        <button
          disabled={!pagedata.previousPage}
          className="pagination_button"
          onClick={() => onPageChange(Number(pagedata.currentPage) - 1)}
        >
          {t("prev")}
        </button>

        <button className="pagination_activebutton">
          {pagedata.currentPage}
        </button>

        <button
          style={{
            padding: "8px 12px",
            backgroundColor: "#f2f2f2",
            border: "1px solid #ddd",
            color: "#333",
            cursor: "pointer",
            transition: "background-color 0.3s ease",
            marginRight: "5px",
            ...(!pagedata.nextPage && {
              cursor: "not-allowed",
              backgroundColor: "#ddd",
            }),
          }}
          disabled={!pagedata.nextPage}
          onClick={() => onPageChange(Number(pagedata.currentPage) + 1)}
          className="pagination_button"
        >
          {t("next")}
        </button>
      </div>
    </div>
  );
}

export default Pagination;
